import React from 'react';
import { useLocation } from 'react-router-dom';
import { Input, Label } from 'reactstrap';
import classnames from 'classnames';

type RadioInputData = {
  label?: string;
  value?: string;
};

export type RadioInputProps = {
  id: string;
  className?: string;
  name?: string;
  data: RadioInputData;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (name: string | undefined, value: string | undefined) => void;
};

const RadioInput = ({
  id,
  className,
  name = '',
  data,
  checked = false,
  disabled = false,
  onChange = () => {},
}: RadioInputProps) => {
  const { pathname } = useLocation();

  /**
   * Reports selection of this radio option to the parent form. Calls onChange with the input name and the bound data value.
   *
   * @returns Nothing.
   */
  const handleChange = () => {
    onChange(name, data.value);
  };

  return (
    <div className={classnames('custom-radio-container', className)}>
      <Input
        type="radio"
        id={`custom-radio-input-${id}`}
        className={classnames('custom-radio-input', disabled ? '--disabled' : '')}
        name={name}
        disabled={disabled}
        checked={checked}
        onChange={handleChange}
      />

      <Label htmlFor={`custom-radio-input-${id}`}>
        {!!data?.label && (
          <span className={`custom-radio-label${pathname === '/events' ? '-layout' : ''}`}>
            {data.label}
          </span>
        )}
      </Label>
    </div>
  );
};

export default RadioInput;
